import styled from "styled-components"

const PersonalBlogWrapper = styled.div``

export default PersonalBlogWrapper
